'use client';

import {useTranslations} from 'next-intl';

export const Hero = () => {
  const t = useTranslations('MainPage.Hero');

  return (
    <div className="flex h-[126px] items-center justify-center bg-[#131424] px-4 md:h-[297px]">
      <h1 className="bg-[linear-gradient(90deg,#F35832_0%,#DF83FF_100%)] bg-clip-text text-center font-montserrat text-[32px] font-bold uppercase leading-[1.1] -tracking-[0.02em] text-transparent md:text-[90px]">
        {t('title')}
      </h1>
    </div>
  );
};
